var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"audio-player"},[_c('audio-visualizer',{attrs:{"frequencies":_vm.frequencies,"bar-color":_vm.barColor}}),_vm._v(" "),_c('audio',{ref:"player",attrs:{"src":_vm.src,"controls":"true","controlslist":"nodownload"},on:{"playing":_vm.startViz,"pause":_vm.stopViz,"ended":_vm.stopViz}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }